var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContacts01 = function SvgContacts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "contacts-01_svg2__a",
    x1: 55.79,
    x2: 190.46,
    y1: 198.85,
    y2: 64.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#contacts-01_svg2__a",
    id: "contacts-01_svg2__b",
    x1: 63.79,
    x2: 198.46,
    y1: 206.84,
    y2: 72.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#contacts-01_svg2__a",
    id: "contacts-01_svg2__c",
    x1: 29.62,
    x2: 164.29,
    y1: 172.68,
    y2: 38.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#contacts-01_svg2__a",
    id: "contacts-01_svg2__d",
    x1: 32.07,
    x2: 166.74,
    y1: 175.13,
    y2: 40.46
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 132.07H90.86c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h57.64c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      fill: "url(#contacts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 148.05H90.86c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h57.64c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      fill: "url(#contacts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5 56.94c0-6.09-5-11.09-11.09-11.09H99.05c-6.09 0-11.09 5-11.09 11.09v2.6c0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9v-2.6c0-2.9 2.3-5.19 5.19-5.19h41.36c2.9 0 5.19 2.3 5.19 5.19V99.9a34.06 34.06 0 0 0-13.19-9.89c2-2.6 3.2-5.89 3.2-9.49 0-8.79-7.09-15.88-15.88-15.88s-15.88 7.09-15.88 15.88 1.2 6.79 3.2 9.49c-5.19 2.1-9.69 5.59-13.19 9.89V73.13c0-1.6-1.3-2.9-2.9-2.9s-2.9 1.3-2.9 2.9v35.06c0 6.09 5 11.09 11.09 11.09h41.36c6.09 0 11.09-5 11.09-11.09V56.84zm-31.77 13.59c5.49 0 9.99 4.5 9.99 9.99s-4.5 9.99-9.99 9.99-9.99-4.5-9.99-9.99 4.5-9.99 9.99-9.99m20.68 42.86H99.05c-2.1 0-3.8-1.2-4.7-3 3.2-7.79 9.69-13.69 17.78-16.08 2.3 1.3 4.9 2 7.59 2s5.39-.7 7.59-2c8.09 2.3 14.59 8.19 17.78 16.08-.8 1.7-2.6 3-4.7 3Z",
    style: {
      fill: "url(#contacts-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77 165.23c1.6 0 2.9-1.3 2.9-2.9V11.19c0-6.19-5-11.19-11.19-11.19H42.91c-6.19 0-11.19 5-11.19 11.19v9.59h-4.5c-5.49 0-9.89 4.4-9.89 9.89s4.4 9.89 9.89 9.89h4.5v14.89h-4.5c-5.49 0-9.89 4.4-9.89 9.89s4.4 9.89 9.89 9.89h4.5v14.89h-4.5c-5.49 0-9.89 4.4-9.89 9.89s4.4 9.89 9.89 9.89h4.5v14.89h-4.5c-5.49 0-9.89 4.4-9.89 9.89s4.4 9.89 9.89 9.89h4.5v14.89h-4.5c-5.49 0-9.89 4.4-9.89 9.89s4.4 9.89 9.89 9.89h4.5v9.59c0 6.19 5 11.19 11.19 11.19h128.57c6.19 0 11.19-5 11.19-11.19v-12.59c0-1.6-1.3-2.9-2.9-2.9s-2.9 1.3-2.9 2.9v12.59c0 3-2.4 5.39-5.39 5.39H67.38V5.89h104.1c3 0 5.39 2.4 5.39 5.39v151.05c0 1.6 1.3 2.9 2.9 2.9M23.23 30.67c0-2.2 1.8-4 4-4h14.79c2.2 0 4 1.8 4 4s-1.8 4-4 4H27.23c-2.2 0-4-1.8-4-4m0 34.56c0-2.2 1.8-4 4-4h14.79c2.2 0 4 1.8 4 4s-1.8 4-4 4H27.23c-2.2 0-4-1.8-4-4m0 34.67c0-2.2 1.8-4 4-4h14.79c2.2 0 4 1.8 4 4s-1.8 4-4 4H27.23c-2.2 0-4-1.8-4-4m0 34.67c0-2.2 1.8-4 4-4h14.79c2.2 0 4 1.8 4 4s-1.8 4-4 4H27.23c-2.2 0-4-1.8-4-4m0 34.56c0-2.2 1.8-4 4-4h14.79c2.2 0 4 1.8 4 4s-1.8 4-4 4H27.23c-2.2 0-4-1.8-4-4m38.36 24.78H42.91c-3 0-5.39-2.4-5.39-5.39v-9.59h4.5c5.49 0 9.89-4.4 9.89-9.89s-4.4-9.89-9.89-9.89h-4.5v-14.89h4.5c5.49 0 9.89-4.4 9.89-9.89s-4.4-9.89-9.89-9.89h-4.5v-14.89h4.5c5.49 0 9.89-4.4 9.89-9.89s-4.4-9.89-9.89-9.89h-4.5V74.92h4.5c5.49 0 9.89-4.4 9.89-9.89s-4.4-9.89-9.89-9.89h-4.5V40.25h4.5c5.49 0 9.89-4.4 9.89-9.89s-4.4-9.89-9.89-9.89h-4.5v-9.59c0-3 2.4-5.39 5.39-5.39h18.68V193.9Z",
    style: {
      fill: "url(#contacts-01_svg2__d)"
    }
  }));
};
export default SvgContacts01;